module.exports = __webpack_public_path__ + "static/dashboardLight-7355294db802d6be256b6d6c0f0353dc.png";